import React from "react";
import { Helmet } from "react-helmet";
import GoToTop from "../GoToTop";
import about from "./assets/images/office.webp";

function AboutUs() {
  return (
    <>
      <Helmet>
        <title>DibruGo | Taxi Service in Dibrugarh</title>
        <meta
          name="description"
          content="Book reliable taxi service in Dibrugarh with DibruGo. Affordable airport transfers, local rides, and outstation trips with professional drivers."
        />
        <meta
          property="og:title"
          content="DibruGo – Best Taxi Service in Dibrugarh | Airport & Local Cabs"
        />
        <meta
          property="og:description"
          content="Book reliable taxi service in Dibrugarh with DibruGo. Affordable airport transfers, local rides, and outstation trips with professional drivers."
        />
        <script type="application/ld+json">
          {`
         {
"@context": "https://schema.org",
"@type": "FAQPage",
"mainEntity": [
{
"@type": "Question",
"name": "How can I book a taxi in Dibrugarh?",
"acceptedAnswer": {
"@type": "Answer",
"text": "You can book a taxi online through DibruGo."
}
},
{
"@type": "Question",
"name": "Does DibruGo provide airport taxi?",
"acceptedAnswer": {
"@type": "Answer",
"text": "Yes, DibruGo provides taxi services to and from Dibrugarh Airport."
}
}
]
}
          `}
        </script>
      </Helmet>
      <GoToTop />
      <div
        className="container section-about web-main pb-4"
        style={{ textAlign: "justify" }}
      >
        <div className="d-flex align-items-center mt-4 mb-3">
          <div className="heading-dash-primary" />
          <h1
            className="fw-bold mb-0 d-flex align-items-center"
            style={{ fontSize: "20px", color: "#f49e00" }}
          >
            {/* <SiSitepoint className="me-2" size={20} /> */}
            DibruGo – Reliable Taxi Service in Dibrugarh
          </h1>
        </div>
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-1">
            <p>
              DibruGo is a modern and reliable taxi booking platform in
              Dibrugarh, designed to provide safe, convenient, and affordable
              transportation for everyone. Our goal is to make travel easier by
              connecting passengers with trusted drivers through a simple and
              efficient booking system.
            </p>

            <p>
              Whether you need a local taxi in Dibrugarh, a quick pick and drop
              ride, or a comfortable intercity cab, DibruGo ensures a smooth and
              hassle-free travel experience.
            </p>

            <h2
              style={{ fontSize: "18px", fontWeight: "bold", color: "#f49e00" }}
              className="mt-3"
            >
              Our Mission
            </h2>
            <p>
              Our mission is to provide fast, safe, and reliable taxi services
              in Dibrugarh and nearby regions while maintaining high standards
              of customer satisfaction. We aim to simplify transportation by
              offering easy cab booking, professional drivers, and transparent
              pricing.
            </p>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 mb-3">
            <img
              src={about}
              alt="DibruGo - Dibrugarh Taxi Service"
              className="img-fluid "
            />
          </div>
        </div>

        <h2
          style={{ fontSize: "18px", fontWeight: "bold", color: "#f49e00" }}
          className="mt-3"
        >
          What Makes DibruGo Different
        </h2>
        <p>
          <b>Easy Taxi Booking : </b>
          With DibruGo, booking a taxi takes only a few seconds. Customers can
          quickly select pickup and drop locations and find available rides
          instantly.
        </p>

        <p>
          <b>Local & Intercity Rides : </b>
          We provide local rides within Dibrugarh as well as intercity taxi
          services to nearby towns and cities, ensuring comfortable
          long-distance travel.
        </p>

        <p>
          <b>Verified Drivers : </b>
          All drivers on DibruGo are verified and trained to ensure safe and
          reliable journeys for every passenger.
        </p>

        <p>
          <b>Quick Pickup : </b>
          Our platform helps customers find nearby drivers quickly, reducing
          waiting time and making travel more efficient.
        </p>

        <p>
          <b>Transparent Pricing : </b>
          We focus on fair and transparent pricing, so customers know what to
          expect before confirming a ride.
        </p>

        <h2
          style={{ fontSize: "18px", fontWeight: "bold", color: "#f49e00" }}
          className="mt-3"
        >
          Our Services
        </h2>

        <p>
          <b>Local Taxi in Dibrugarh : </b>
          DibruGo offers reliable local taxi services in Dibrugarh for daily
          travel, shopping, office commutes, and more.
        </p>

        <p>
          <b>Airport Transfers : </b>
          Book a comfortable taxi to or from the Dibrugarh Airport for
          stress-free airport transportation.
        </p>

        <p>
          <b>Intercity Taxi Service : </b>
          Travel between cities with our safe and comfortable intercity rides,
          perfect for business trips, family travel, or long journeys.
        </p>

        <p>
          <b>Cab Reservation : </b>
          Customers can reserve taxis in advance for planned travel or multi-day
          trips.
        </p>

        <h2
          style={{ fontSize: "18px", fontWeight: "bold", color: "#f49e00" }}
          className="mt-3"
        >
          Our Vision
        </h2>
        <p>
          Our vision is to become the most trusted taxi service in Assam,
          starting from Dibrugarh and expanding to more cities while maintaining
          excellent service quality.
        </p>

        <h2
          style={{ fontSize: "18px", fontWeight: "bold", color: "#f49e00" }}
          className="mt-3"
        >
          Why Customers Choose DibruGo
        </h2>

        <ul>
          <li>Reliable taxi service in Dibrugarh</li>
          <li>Easy and fast online cab booking</li>
          <li>Professional and verified drivers</li>
          <li>Affordable and transparent pricing</li>
          <li>Comfortable rides for local and intercity travel</li>
        </ul>

        <h1
          style={{ fontSize: "18px", fontWeight: "bold", color: "#f49e00" }}
          className="mt-3"
        >
          Book Your Ride Today
        </h1>
        <p>
          With DibruGo, getting a ride is simple. Book your taxi today and enjoy
          safe, reliable, and convenient travel in Dibrugarh and beyond.
        </p>
      </div>
    </>
  );
}

export default AboutUs;
